import {COMPANY_NAME} from '../utils';

const Iframe = () => {
  const source =
    'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3015.9448334908516!2d29.261689499999985!3d40.895025!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14cadb6c7b74d563%3A0x10838d4450858bda!2sVelibaba%2C%20Veli%20Baba%20Sanayi%20Sitesi%20No%3A31%2C%2034896%20Pendik%2F%C4%B0stanbul!5e0!3m2!1sen!2str!4v1721500642209!5m2!1sen!2str';

  return (
    <iframe
      src={source}
      name={COMPANY_NAME}
      title={COMPANY_NAME}
      width="100%"
      height={450}
      allowFullScreen={true}
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"></iframe>
  );
};

export default Iframe;
